<template>
  <ul
    :class="{
      'grid grid-cols-3 gap-2 lg:grid-cols-7': group.displayType === 'media',
      'flex flex-wrap gap-2': group.displayType === 'text',
    }"
  >
    <ShopProductVariantOption
      v-for="option in group.options"
      :key="option.id"
      :option="option"
      @change="emit('change', option.id)"
    />
  </ul>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

defineProps<{
  group: Schemas['PropertyGroup']
}>()

const emit = defineEmits(['change'])
</script>
